var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticStyle:{"overflow":"visible"},attrs:{"disabled":_vm.disabled}},[_c('legend',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('table',{staticClass:"dataTable mergeTable",attrs:{"width":"100%"}},[_c('tbody',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }